// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClaimPayoutModal-errorMessage-IuNm4 {
	color: var(--alert-color);
}

.ClaimPayoutModal-fullWidth-ETOIF {
	width: 100%;
}

@media screen and (max-width: 1200px) and (min-width: 768px) {
	.ClaimPayoutModal-disPlayInline-tK505 {
		width: 50%;
		margin: 18px auto 0;

	}
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/ClaimPayoutModal/ClaimPayoutModal.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;AAC1B;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC;EACC,UAAU;EACV,mBAAmB;;CAEpB;AACD","sourcesContent":[".errorMessage {\n\tcolor: var(--alert-color);\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n@media screen and (max-width: 1200px) and (min-width: 768px) {\n\t.disPlayInline {\n\t\twidth: 50%;\n\t\tmargin: 18px auto 0;\n\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ClaimPayoutModal-errorMessage-IuNm4`,
	"fullWidth": `ClaimPayoutModal-fullWidth-ETOIF`,
	"disPlayInline": `ClaimPayoutModal-disPlayInline-tK505`
};
module.exports = ___CSS_LOADER_EXPORT___;
